module.exports = __webpack_public_path__ + "static/media/Mask Group 175.5920ca48.svg";